<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Колокейшены") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">
            {{ $t("message.Колокейшены") }}
          </li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-button
        :disabled="!hasUpdatePermissions"
        :variant="'success'"
        class="mb-1 float-right"
        @click="addRow()"
        >{{ $t("message.Добавить") }}</b-button
      >
      <b-table
        id="colocation-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="actions" slot-scope="row">
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            :disabled="!hasUpdatePermissions"
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
        <template slot="enabled" slot-scope="data">
          <i
            class="fa fa-check"
            aria-hidden="true"
            v-if="data.item.enabled == true"
          ></i>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="data.item.enabled == false"
          ></i>
        </template>
        <template slot="colocation" slot-scope="data">
          <b-badge class="mr-1" :key="data.item.colocation.id">{{
            data.item.colocation.name
          }}</b-badge>
        </template>
        <template slot="spare_enabled" slot-scope="data">
          <i
            class="fa fa-check"
            aria-hidden="true"
            v-if="data.item.spare_enabled == true"
          ></i>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="data.item.spare_enabled == false"
          ></i>
        </template>
        <template slot="spare_colocation" slot-scope="data">
          <b-badge
            class="mr-1"
            v-if="data.item.spare_colocation != null"
            :key="data.item.spare_colocation.id"
            >{{ data.item.spare_colocation.name }}</b-badge
          >
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>

      <b-modal
        id="modalInfo"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Колокейшены_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <ColocationForm :model="colocationModel"></ColocationForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ColocationForm from "./ColocationForm";
import Vue from "vue";

export default {
  name: "Colocations",
  components: {
    ColocationForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        { key: "enabled", sortable: false },
        { key: "spare_enabled", sortable: false },
        { key: "spare_colocation", sortable: false },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      colocationModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    hasUpdatePermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "colocations:fully_manage")
        .length;
    },
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(
          value =>
            value == "colocations:fully_manage" ||
            value == "colocations:set_spare_enabled"
        ).length;
    }
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("colocations", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.colocationModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_запись?"))
        .then(response => {
          this.$noname
            .delete("colocations", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "colocation-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    },
    addRow() {
      this.colocationModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.colocationModel.id > 0) {
        this.$noname
          .patch("colocations", this.colocationModel.id, this.colocationModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "colocation-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("colocations", this.colocationModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "colocation-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Colocations.vue